module.exports = __webpack_public_path__ + "static/media/icsa-landscape.907e8e0e.svg";